module.exports = __webpack_public_path__ + "static/cover_tablet-2f07411ad91f7b72abdf4ff2c4c16fc8.mp4";